import * as Sentry from '@sentry/react'

import { ORDER_STATUS_TRANSLATION_IDS } from 'Constants/orderStatus'

import { dashOrSpaceToUnderscore } from '../dashOrSpaceToUnderscore/dashOrSpaceToUnderscore.util'

export const getCaseItemStatusTranslationId = (caseItemStatus: string) => {
  const formattedStatus = dashOrSpaceToUnderscore(caseItemStatus)
  const translationId =
    formattedStatus in ORDER_STATUS_TRANSLATION_IDS
      ? ORDER_STATUS_TRANSLATION_IDS[
          formattedStatus as keyof typeof ORDER_STATUS_TRANSLATION_IDS
        ]
      : undefined

  if (!translationId) {
    Sentry.captureException(
      new Error(
        `getCaseItemStatusTranslationId: unknown case status returned from the API: ${formattedStatus}`,
      ),
    )

    return 'Unknown_case_status'
  }

  return translationId
}
